import { RichTextBlock } from "./RichtextBlock";
import { ListProps } from "./types";

export const RichTextList = ({ list }: ListProps) => {

  
  return (
    <div data-testid="listItem">
      {list.map((listItem, index) => {

        const { item, nestedList } = listItem;

        if(item) {
          return (
            <li key={index}>
              <span dangerouslySetInnerHTML={{ __html: item || "" }} />
              {nestedList && (
                <div className="nested-list">
                  <RichTextBlock item={nestedList} />
                </div>
              )}
            </li>
          );
        }
        return <RichTextBlock item={listItem} key={index} />;
      })}
    </div>
  );
};
